export default __webpack_public_path__ + "static/media/Fidelity-Computer-Crime-insurance-policy-2025.ac3452b8.pdf";